import { Card, CardContent, CardHeader } from '@/shared/components/ui/card';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { useLingui } from '@lingui/react/macro';

/**
 * Loading placeholder for {@link OrganizationManagementPage}, shown as the route's
 * `pendingComponent` while the loader warms the organizations + per-org projects
 * queries. Mirrors the org-card inventory layout.
 */
export function OrganizationInventorySkeleton() {
  const { t } = useLingui();
  return (
    <div className="flex flex-1 flex-col gap-6 p-6">
      <div className="space-y-4" aria-label={t`Loading organizations`}>
        {[0, 1].map((index) => (
          <Card key={index} className="shadow-none">
            <CardHeader className="border-b">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-4 w-28" />
            </CardHeader>
            <CardContent className="space-y-2 pt-4">
              <Skeleton className="ml-9 h-14" />
              <Skeleton className="ml-9 h-14" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
